//client\src\calendar\helpers\getTrackerEvents.js

import dayjs from "dayjs";

/**
 * getTrackerEvents
 *
 * Generates FullCalendar-compatible events for trackers
 * within the currently visible calendar range.
 *
 * This function is PURE:
 * - no mutations
 * - no side effects (except reading calendarRef)
 *
 * @param {Object} params
 */
export function getTrackerEvents({
    trackers = [],
    settings = {},
    calendarFilters = {},
    enabledItemTypes = {},
    itemTypeColors = {},
    calendarRef,
    format,
}) {
    // Only show trackers if enabled
    if (!(calendarFilters.trackers && enabledItemTypes.trackers)) {
        return [];
    }

    const showMissed = Boolean(settings.showMissedTrackers);
    const missedColor =
        itemTypeColors.missedTrackers ||
        itemTypeColors.trackers ||
        "#999";

    const api = calendarRef?.current?.getApi?.();
    const activeStart = api?.view?.activeStart;
    const activeEnd = api?.view?.activeEnd;

    if (!activeStart || !activeEnd) return [];

    const start = dayjs(activeStart).startOf("day");
    const end = dayjs(activeEnd).startOf("day");

    const events = [];

    trackers.forEach((tracker) => {
        let current = start.clone();

        while (current.isSameOrBefore(end, "day")) {
            const dateStr = current.format("YYYY-MM-DD");

            const completed = tracker.history?.some(
                (h) => format(h.date) === dateStr
            );

            // Include if completed OR showing missed
            if (completed || showMissed) {
                events.push({
                    title: tracker.title,
                    date: dateStr,
                    allDay: true,
                    color: completed
                        ? itemTypeColors.trackers
                        : missedColor,
                    extendedProps: {
                        ...tracker,
                        type: "tracker",
                        completed,
                        missed: !completed,
                    },
                });
            }

            // Increment based on frequency
            switch (tracker.frequency) {
                case "weekly":
                    current = current.add(1, "week");
                    break;
                case "monthly":
                    current = current.add(1, "month");
                    break;
                default:
                    current = current.add(1, "day");
            }
        }
    });

    return events;
}
